import aliPay from './ali-pay.png'
import wechatPay from './wechat-pay.png'

interface PayButtonProps {
  type: 'ALIPAY' | 'WXPAY'
  onClick: (type: PayButtonProps['type']) => void | Promise<void>
  isLoading?: boolean
  className?: string
}

export default function PayButton(props: PayButtonProps) {
  const { type, onClick, isLoading = false, className = '' } = props
  return (
    <button
      onClick={() => {
        if (!isLoading) {
          void onClick(type)
        }
      }}
      className={`before:content-[''] ${isLoading ? 'cursor-not-allowed' : ''} ${className}`}
      un-w="full"
      un-h="13"
      un-position="relative"
      un-cursor="pointer"
      un-flex=""
      un-items="center"
      un-justify="left"
      un-rounded="[5px]"
      un-bg="gradient-to-r"
      un-from="[rgba(254,153,33,0.1)]"
      un-to="[rgba(255,66,59,0.1)]"
      un-border="0"
      un-outline="none"
      un-before="absolute -inset-[2px] -z-1 focus:bg-gradient-to-r from-[#FE9921] to-[#FF423B] rounded-[6px]">
      <img className="h-8 ml-3" src={type === 'ALIPAY' ? aliPay : wechatPay} alt="" />
      <span className="ml-2 text-base font-medium text-[#282828]">{type === 'ALIPAY' ? '支付宝支付' : '微信支付'}</span>
    </button>
  )
}
